<template>
  <CrudForm :title="title" :labelSubmit="labelSubmit" :storeName="storeName" :parentStoreName="parentStoreName"
    :parentUrlKey="parentUrlKey" :submit="submit" :status="status" labelBack="Atrás"
    :urlSendNotification="urlSendNotification">
    <ValidationObserver ref="validator" v-slot="{ errors }">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider ref="address" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Lugar</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.address" label="Lugar" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
              <span class="color-danger">{{
                  customerrors ? customerrors.errors?.msg : ""
                }}</span>
              <GoogleMapLoader v-on:select="changeAddress" :show-map="false" :sendCoordinates="sendCoordinates" />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="unit" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Unidad</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.unit" label="Unidad" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="seat_quantity" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Cantidad de Espacios</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.seat_quantity" label="Cantidad de Espacios" solo
                              hide-details="auto" class="input-base">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.latitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.latitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>

                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="spot_price_hour" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Spot Precio Hora</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.spot_price_hour" label="Spot Precio Hora" solo
                              hide-details="auto" class="input-base">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.latitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.latitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="name" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Nombre</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.name" label="Nombre" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="subtype" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Sub Tipo</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.subtype" label="Sub Tipo" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>

              <ValidationProvider ref="province_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Provincia</div>
                <v-select :error-messages="errors" v-model="data.province_id" :items="provinces" item-text="name"
                          item-value="id" label="Provincia" solo hide-details="auto" class="input-base"
                          append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="city_id" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Ciudad</div>
                <v-select :error-messages="errors" v-model="data.city_id" :items="cities" item-text="name"
                          item-value="id" label="Ciudad" solo hide-details="auto" class="input-base"
                          append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>

              <ValidationProvider ref="street" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Calle</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.street" label="Calle" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>

              <ValidationProvider ref="number" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Número</div>
                <v-text-field id="pac-input" :error-messages="errors" v-model="data.number" label="Número" solo
                              hide-details="auto" class="input-base"></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>

              <ValidationProvider ref="latitude" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Latitud</div>
                <v-text-field :error-messages="errors" v-model.number="data.latitude" type="Number" label="Latitud" solo
                              hide-details="auto" class="input-base no-spinner">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.latitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.latitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
            <v-col>

              <ValidationProvider ref="longitude" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Longitud</div>
                <v-text-field :error-messages="errors" type="Number" v-model.number="data.longitude" label="Longitud"
                              solo hide-details="auto" class="input-base  no-spinner">
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="() => data.longitude++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="() => data.longitude--">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
                </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="status" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Estado</div>
                <v-select :error-messages="errors" v-model="data.status" label="Estado" :items="status_types" solo
                          hide-details="auto" class="input-base" append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="size" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tamaño</div>
                <v-select :error-messages="errors" v-model="data.size" :items="size_spots" item-text="title"
                          item-value="id" label="Tamaño" solo hide-details="auto" class="input-base"
                          append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
            <v-col>
              <ValidationProvider ref="type_spot_id" rules="required" v-slot="{ errors }">
                <div class="label-base pb-1">Tipo</div>
                <v-select :error-messages="errors" v-model="data.type_spot_id" :items="type_spots" item-text="name"
                          item-value="id" label="Tipo" solo hide-details="auto" class="input-base"
                          append-icon="$caretDownFormIcon"></v-select>
              </ValidationProvider>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <ValidationProvider ref="verified" rules="" v-slot="{ errors }">
                <div class="label-base"></div>
                <v-checkbox :error-messages="errors" label="Verified" v-model.number="data.verified"
                            class="input-check-base mt-5" hide-details="auto" on-icon="$checkedIcon" off-icon="$unCheckedIcon">
                </v-checkbox>
              </ValidationProvider>
            </v-col>
            <v-col class="py-8 px-2">
              <ValidationProvider ref="deleted" rules="" v-slot="{ errors }">
                <v-checkbox v-model="data.deleted" label="Eliminado" class="input-check-base mt-0" hide-details="auto"
                            on-icon="$checkedIcon" off-icon="$unCheckedIcon">
                </v-checkbox>
              </ValidationProvider>
            </v-col>
            <v-col class="py-8 px-2">
              <v-checkbox v-model="data.has_sticker" label="Cartel colocado " class="input-check-base mt-0"
                          hide-details="auto" on-icon="$checkedIcon" off-icon="$unCheckedIcon"></v-checkbox>
            </v-col>
          </v-row>
          <v-row class="mt-2" no-gutters>
            <v-col class="py-0 px-2">
              <ValidationProvider ref="type" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Comodidades</div>
                <v-select :error-messages="errors" v-model="data.amenities" label="Comodidades" :items="amenities"
                          item-text="name" item-value="id" multiple solo hide-details="auto" class="input-base"
                          append-icon="$caretDownFormIcon">
                  <template slot="no-data">
                    <v-alert :value="true"> No hay datos a mostrar </v-alert>
                  </template>
                </v-select>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>

              <ValidationProvider ref="description" rules="" v-slot="{ errors }">
                <div class="label-base pb-1">Descripción</div>
                <v-textarea :error-messages="errors" v-model="data.description" label="" solo
                            placeholder=" Ingrese aquí la información adicional" hide-details="auto" class="text-tarea-base"
                            counter="200" :rules="[v => v.length <= 200 || 'Máximo 200 caracteres']" rows="8">
                </v-textarea>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <ValidationProvider ref="picture" rules="" v-slot="{ errors }">
                <Upload :error-messages="errors" accept="image/png, image/jpeg, image/jpg" placeholder="Imagen de Spots"
                        prepend-icon="fas fa-camera" label="" :multiple="false" :onSelectedPicture="onSelectedPicture">
                </Upload>
                <v-img class="mx-auto" :src="picture_poster" width="200"></v-img>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row v-if="images_poster && images_poster.length > 0">
            <v-col cols="12">
              Fotos Poster
            </v-col>
          </v-row>
          <div class="images_poster">
            <v-row>
              <v-col v-for="(item, i) in images_poster" :key="'img_' + i" class="d-flex child-flex" cols="3">
                <a :href="item" target="_blank">
                  <img :src="item" alt="" title="" class="img-default" />
                </a>
              </v-col>
            </v-row>
          </div>
          <v-row v-if="spot_document.spot_document">
            <v-col>
              <v-btn text class="mr-5" :href="spot_document.spot_document" target="_blank">
                <v-icon left>fas fa-file</v-icon>
                Documento de Spot
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import GoogleMapLoader from "@/components/maps/GoogleMapLoader";
export default {
  mixins: [CrudFormMixin],
  components: {
    ValidationProvider,
    ValidationObserver,
    CrudForm,
    GoogleMapLoader,
    Upload,
  },
  computed: {
    ...mapState({
      status: (state) => state.Spots.status,
      customerrors: (state) => state.Spots.customerrors,
      type_spots: (state) => state.Type_spots.list,
      size_spots: (state) => state.Size_spots.list,
      provinces: (state) => state.Provinces.list,
      cities: (state) => state.Cities.list,
      amenities: state => state.Amenities.list
    }),
  },
  mounted() { },
  async created() {
    const self = this;
    let filters = {};
    this.urlSendNotification = "";

    if (this.$route.params.user_id) {
      this.data.user_id = this.$route.params.user_id;
      filters.user_id = this.$route.params.user_id;
    }
    if (this.$route.params.id) {
      await self.$store
        .dispatch("Spots/show", this.$route.params.id)
        .then(async (val) => {
          this.data.type_spot_id = val.type_spot;
          await this.$store.dispatch("Cities/getListAll", {
            enable: true,
            province_id: val.province_id,
          });
        });

      filters.spot_id = this.$route.params.id;
      const posters = await self.$store.dispatch("Posters/getListAll", {
        spot_id: filters.spot_id,
      });
      if (posters && posters.length > 0) {
        const poster = posters[0];
        const valid_photos = poster.photos.filter((item) => item.photo);
        this.images_poster = valid_photos.map((item) => item.photo);
      }

      this.urlSendNotification =
        "/admin/users/" +
        this.$route.params.user_id +
        "/message/send/" +
        this.$route.params.id +
        "?name=" +
        (this.data.address ? this.data.address : "");
    }
    await self.$store.dispatch("Spots/getListAll", filters);
    await self.$store.dispatch("Type_spots/getListAll", filters);
    await self.$store.dispatch("Size_spots/getListAll", {});
    await self.$store.dispatch("Provinces/getListAll", { enable: true });
    await this.$store.dispatch("Amenities/getListAll", { show_all: "enable" });
  },
  data() {
    return {
      images_poster: [],
      parentStoreName: "Users_scroll",
      parentUrlKey: "user_id",
      storeName: "Spots",
      title: "Spots",
      status_types: [
        "in_use",
        "available",
        "unavailable",
        "verification_rejected",
      ],
      spot_document: {
        spot_document: null,
      },
      availability_types: ["full_time", "part_time", "my_time"],
      filteredAttributes: ["picture"],
      picture_poster: "",
      data: {
        user_id: "",
        address: "",
        latitude: "",
        longitude: "",
        location: "",
        size: "",
        status: "",
        availability: "",
        type_spot_id: "",
        verified: false,
        deleted: false,
        description: "",
        unit: "A",
        picture: undefined,
        province_id: "",
        city_id: "",
        has_sticker: false,
        seat_quantity: "",
        spot_price_hour: "",
        subtype: "",
        name: "",
        street: "",
        number: "",
        amenities: []
      },
      time_to: "",
      time_from: "",
      menu_time_to: false,
      menu_time_from: false,
      urlSendNotification: "",
    };
  },
  watch: {
    time_to(val) {
      this.time_to = val;
      this.data.time_to = this.formatDateForSave(val);
    },
    time_from(val) {
      this.time_from = val;
      this.data.time_from = this.formatDateForSave(val);
    },
    async "data.province_id"(val) {
      this.data.city_id;
      await this.$store.dispatch("Cities/getListAll", {
        enable: true,
        province_id: val,
      });
    },
  },
  methods: {
    onCreate(data) {
      // this.data.size_spot_id = data.size;
      this.spot_document = {
        ...this.spot_document,
        ...data.spot_document,
      };
    },
    sendCoordinates(lat, lng) {
      this.data.latitude = lat;
      this.data.longitude = lng;
    },
    changeAddress(val) {
      this.data.address = val;
    },
    onSelectedPicture(file) {
      const self = this;
      this.data.picture = file;

      let fr = new FileReader();
      fr.onload = function () {
        self.picture_poster = fr.result;
      };
      fr.onerror = function () {
        self.picture_poster = "";
      };
      fr.readAsDataURL(this.data.picture);
    },
  },
};
</script>
